import { render, staticRenderFns } from "./costAnalysisComponent.vue?vue&type=template&id=9cd66bf6&scoped=true"
import script from "./costAnalysisComponent.vue?vue&type=script&lang=js"
export * from "./costAnalysisComponent.vue?vue&type=script&lang=js"
import style0 from "./costAnalysisComponent.vue?vue&type=style&index=0&id=9cd66bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd66bf6",
  null
  
)

export default component.exports